module.exports = __webpack_public_path__ + "img/skycharms.b44bae96.jpg";